import {Component, ElementRef, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';

@Component({
	selector: 'disclosure',
	templateUrl: './disclosure.component.html',
	styleUrls: ['./disclosure.component.scss'],
	standalone: false
})
export class DisclosureComponent implements OnInit {
	private readonly _matDialogRef: MatDialogRef<DisclosureComponent>;
	private readonly positionRelativeToElement: ElementRef;
	private readonly type: string;
	private readonly mouseEvent: MouseEvent;

	constructor(_matDialogRef: MatDialogRef<DisclosureComponent>,
				@Inject(MAT_DIALOG_DATA) data: { positionRelativeToElement: ElementRef, val: string, $event: MouseEvent }) {
		this._matDialogRef = _matDialogRef;
		this.positionRelativeToElement = data.positionRelativeToElement;
		this.type = data.val;
		this.mouseEvent = data.$event;
	}

	ngOnInit(): void {
		const matDialogConfig: MatDialogConfig = new MatDialogConfig();

		matDialogConfig.position = {
			left: `${this.mouseEvent.clientX + window.scrollX - 200}` + 'px',
			top: `${this.mouseEvent.clientY + window.scrollY - 10}` + 'px'

		};

		matDialogConfig.height = '260px';
		matDialogConfig.width = '227px';
		this._matDialogRef.updateSize(matDialogConfig.width, matDialogConfig.height);
		this._matDialogRef.updatePosition(matDialogConfig.position);

	}

}
